export default __webpack_public_path__ + "static/media/up_icon_green.b2d33f22.svg";